import dropin from "braintree-web-drop-in"
import { getClientToken } from "./common"
import Swal from "sweetalert2";

export default async function updatePaymentUI(){
    
    const initBtn = document.getElementById("update-payment-details")
    
    initBtn.addEventListener("click", async () => {
        
        const form = document.getElementById("subscription-payment-form")
        const billing_name = document.getElementById("name").value
        const uuid = document.getElementById("uuid").value

        const braintree_id = form.dataset.bid

        var token = await getClientToken(braintree_id) //braintree_id
        if(!token) return

        console.log("v2");

        dropin.create({
            authorization: token,
            container: "#dropin-container",
            dataCollector: true,
            threeDSecure: true,
            translations: {
                payWithCard: "Update your payment details"
            },

            // paypal: {
            //     flow: "vault"
            // }
            
        }).then((instance) => {

            $("#payment-detail-continer").slideDown()
            $("#update-payment-details").slideUp()
            
            form.addEventListener("submit", (event) => {
                event.preventDefault()
                
                disableSubmitBtn()
                
                instance.requestPaymentMethod({
                    threeDSecure: {
                        amount: "0",
                        name: billing_name
                    }
                }).then(async(payload) => {
                    
                    await fetch(`/services/braintree/subscription-update-payment.php?bid=${braintree_id}`, {
                        method: "POST",
                        headers: {
                            "content-type": "application/x-www-form-urlencoded", //"application/json"
                        },
                        body: new URLSearchParams({
                            "uuid": uuid,
                            "nonce": payload.nonce,
                            "deviceData": payload.deviceData
                        })
                    })
                    .then(resp => {
                        if(resp.ok) return resp.json()
                        showErrorMsg("An error occurred while updating your payment details. Please try again.")
                        enableSubmitBtn()
                        return;
                    })
                    .then((data) => {
                        if(data.error){
                            showErrorMsg(data.error.message)
                            enableSubmitBtn()
                        } else {
                            showSuccessMsg("Your payments have been updated")
                            $("#payment-holder").slideUp()
                        }
                    })
                    
                }).catch((error) => { 
                    showErrorMsg("3D Secure failed. Please check your details and try again.")    
                    enableSubmitBtn()    
                    throw error; 
                })            
            })
            
            enableSubmitBtn()
            
        }).catch((error) => {
            // Handle error in Drop-in creation
            
            showErrorMsg(error)   
            enableSubmitBtn()     
        });

        
    })
    
    
    
}

function enableSubmitBtn(){
    $("#checkout-submit-btn").removeAttr("disabled")
}

function disableSubmitBtn(){
    $("#checkout-submit-btn").prop("disabled", true)
}

function showErrorMsg(errorMsg){
    Swal.fire({
        icon: "error",
        title: "Error",
        html: errorMsg
    })    
}

function showSuccessMsg(msg){
    Swal.fire({
        icon: "success",
        title: "Success",
        html: msg
    })  
}